export default [
    {
      path: 'd-fin/gefin-contatos',
      name: 'gefin-contatos',
      component: () => import('./index'),
      children: [],
      meta: {
        visible: false,
        title: 'Contatos',
        order: '3',
        breadcrumb: [
          { name: 'Home', link: 'home' },
          { name: 'D-FIN', link: 'd-fin' },
          { name: 'Cadastros' }
        ]
      }
    },
  ]